import { Link } from 'react-router';
import { Icons } from 'markcat-ui';
import styles from './BillingReturn.module.css';

/**
 * Stripe redirect target when the user abandons the checkout flow.
 * No charges were made. Offer a path back to pricing or the app.
 */
export function BillingCancel() {
  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={`${styles.icon} ${styles.iconCancel}`} aria-hidden="true">
          <Icons.CloseIcon size={32} />
        </div>
        <h1 className={styles.title}>Checkout cancelled</h1>
        <p className={styles.subtitle}>
          No charges were made. You can review the plans again or head back to the app.
        </p>
        <div className={styles.actions}>
          <Link to="/app/billing" className={styles.ctaPrimary}>See plans</Link>
          <Link to="/app" className={styles.cta}>Back to app</Link>
        </div>
      </div>
    </div>
  );
}
